import PropTypes from 'prop-types'
import React, { Component } from 'react'

import noop from 'lodash/noop'
import isNil from 'lodash/isNil'
import classNames from 'classnames'

import SimpleModal from '../SimpleModal'
import Popover from '@/checkout-instore-legacy/components/Commons/Popover'
import Button from '../Button'

import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

class Selector extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showOptionsList: false,
    }
  }

  handleShowOptions = () => {
    this.setState({ showOptionsList: true })
  }

  handleHideOptions = () => {
    this.setState({ showOptionsList: false })
  }

  handleSelect = (value, label) => {
    this.handleHideOptions()
    this.props.onSelect(value, label)
  }

  renderDefaultButton = ({
    currentValue,
    handleMenuOpen,
    label,
    highlight,
  }) => {
    return (
      <div
        className={
          'flex items-center ph4 ph5-ns mt3 mt5-ns mt4-l ph5-ns f4-ns mt0-l ph0-l mb4'
        }
      >
        {label !== null && (
          <div className="flex-none w-30 w-25-ns pr5 tr dn-l">{label}</div>
        )}
        <div className={classNames('flex-auto', { glow: highlight })}>
          <Button
            size="md"
            inline={false}
            fixedValue={false}
            kind="light-primary"
            onClick={handleMenuOpen}
          >
            {currentValue}
          </Button>
        </div>
      </div>
    )
  }

  render() {
    const {
      data,
      label,
      highlight,
      placeholder,
      renderCustomButton,
      popoverEnabled,
      alwaysPopover,
      mediaQuery,
    } = this.props

    const usePopover = mediaQuery({
      phone: alwaysPopover,
      desktop: popoverEnabled || alwaysPopover,
    })

    const selectedItem = data.find((item) => item.selected)
    const currentValue = selectedItem != null ? selectedItem.label : placeholder
    const { showOptionsList } = this.state

    const renderButton = isNil(renderCustomButton)
      ? this.renderDefaultButton
      : renderCustomButton

    const content = (usePopover || showOptionsList) && (
      <div
        className="tc"
        style={{
          maxHeight: '80vh',
        }}
      >
        {data.map((item, index) => {
          return (
            <div
              key={item.key || index}
              className="flex flex-column items-center"
            >
              <Button
                checked={item.selected}
                inline={false}
                size="lg"
                kind="dropdown"
                disabled={item.disabled}
                onClick={() => this.handleSelect(item.value, item.label)}
                value={item.value}
              >
                {item.label}
              </Button>
              {index < data.length - 1 && (
                <hr className="ma0 bg-black-20 w-80" />
              )}
            </div>
          )
        })}
      </div>
    )

    return (
      <div>
        <div
          ref={(el) => {
            this.buttonContainer = el
          }}
        >
          {renderButton({
            currentValue,
            handleMenuOpen: this.handleShowOptions,
            label,
            highlight,
          })}
        </div>
        {usePopover ? (
          <Popover
            visible={showOptionsList}
            offsetY={-10}
            maxWidth={500}
            source={this.buttonContainer}
            onClose={this.handleHideOptions}
          >
            {content}
          </Popover>
        ) : (
          showOptionsList && (
            <SimpleModal onClose={this.handleHideOptions}>
              {content}
            </SimpleModal>
          )
        )}
      </div>
    )
  }
}

Selector.propTypes = {
  value: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.array.isRequired,
  ]),
  label: PropTypes.string,
  onSelect: PropTypes.func,
  highlight: PropTypes.bool,
  placeholder: PropTypes.string,
  renderCustomButton: PropTypes.func,
  popoverEnabled: PropTypes.bool,
  alwaysPopover: PropTypes.bool,
  mediaQuery: PropTypes.func.isRequired,
}

Selector.defaultProps = {
  value: null,
  label: null,
  highlight: false,
  placeholder: '',
  onSelect: noop,
  renderCustomButton: null,
  popoverEnabled: false,
  alwaysPopover: false,
}

export default withMediaQuery(Selector)
